import { Components, Theme } from "@mui/material";

export const muiTableTheme = (
  theme: Theme,
): Pick<Components<Omit<Theme, "components">>, "MuiTable"> => ({});
